<script setup lang="ts">
import AppHeader from '@/components/layout/AppHeader.vue'
</script>

<template>
  <div class="h-screen h-dvh overflow-hidden bg-base flex flex-col">
    <AppHeader />
    <main class="flex-1 min-h-0">
      <RouterView />
    </main>
  </div>
</template>
